import { getHeaders, CheckAuth } from 'auth/auth';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

const isUuidLike = (value) => {
  if (!value) return false;
  return /^[0-9a-fA-F-]{36}$/.test(String(value));
};

const isConsumerUser = () => {
  const cachedUser = CheckAuth() || {};
  const role = String(cachedUser.role || cachedUser.originalRole || '').toLowerCase();
  const userId = cachedUser.user_id;
  return role === 'consumer' || isUuidLike(userId);
};

export const notificationsAPI = createApi({
  reducerPath: 'notifications',
  tagTypes: ['fetch-notifications'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: ({ showUnread }) => {
        // B2C consumers use /b2c/notifications/, B2B uses /loan/notification/
        const url = isConsumerUser()
          ? `b2c/notifications/?page=1&page_size=100&is_unread=${showUnread}`
          : `loan/notification/?page=1&page_size=100&is_unread=${showUnread}`;
        return {
          url,
          method: 'GET',
          headers: getHeaders(),
        };
      },
      providesTags: ['fetch-notifications'],
    }),

    updateNotifications: builder.mutation({
      query: ({ data }) => {
        // B2C consumers use /b2c/notifications/, B2B uses /loan/notification/
        const url = isConsumerUser() ? `b2c/notifications/` : `loan/notification/`;
        return {
          url,
          method: 'PUT',
          body: data,
          headers: getHeaders(),
        };
      },
      invalidatesTags: ['fetch-notifications'],
    }),
  }),
});

export const { useGetNotificationsQuery, useUpdateNotificationsMutation } =
  notificationsAPI;
